import axios from 'axios'

export function getCreditNoteAsPdf (CreditNoteId: number|string) {
  return axios.get('/credit-notes/' + CreditNoteId + '/pdf', {
    responseType: 'blob'
  })
}
